import React from 'react';

const Footer = () => (
    <div className="footer">
        <div>
            ©  <a href="https://voidpointer.se/">Void Pointer</a> 2019,{' '}
            <a href="https://voidpointer.se/plattform">VPBase 4.0</a>
        </div>
    </div>
);

export default Footer;
